import React from 'react';
import PropTypes from 'prop-types';
import ModalV4 from '../../../../app/ui/modal/v4/v4';

// @ts-ignore
import Api from "../../../gd/api/api";

import CreateExisting from './add-existing/add-existing';
import ModalCustomField_Form from './create-new/form';
import ModalCustomField_Step2Form from "./create-new/steps/step-2-form";
import SessionCustomField from "../../../model2/custom-field/session-custom-field";
import {getTaskCustomFieldByType} from "../../../fields/custom-field-factory";
import ModalCustomField_EditFieldV3 from "./edit/edit-field-v3";
import {CustomFieldScope} from "../../../model2/custom-field/@const";

export type ModalCustomFieldParams = {
    newOnly         : boolean
    customField?    : SessionCustomField // gd.session.customField

    title?          : string
    onSubmit?       : callback
    callback?       : callback          // important

    scope?          : CustomFieldScope[]
    mandatoryScope? : CustomFieldScope[]

    // params      : {
    //     notification?   : any
    //     project?        : any
    //     taskType?       : any
    // }
}

export enum ModalCustomField_Mode {
    NEW         = 'new',
    EDIT        = 'edit',
    EXISTING    = 'existing'    // add existing ?
}

type Props = {
    params          : ModalCustomFieldParams
    className?      : string
}

type State = {
    curValue        : ModalCustomField_Mode | number // a mozet i net ... po hodu eche TYPE pf custom field mozet soderzat' ????
}

// const debug = "ModalCustomField"
const debug = false

export default class ModalCustomField extends ModalV4 {

    constructor(props: Props) {
        super(props)

        debug && console.log(debug, "constructor() params=", this.props.params)

        let curValue = props.params.newOnly ? ModalCustomField_Mode.NEW : ModalCustomField_Mode.EXISTING
        if (props.params.customField) {
            curValue = ModalCustomField_Mode.EDIT
        }

        this.state = {
            curValue: curValue,
        }

        debug && console.log("    curValue (state) = ", curValue)
    }

    onClickNew = () => {
        this.setState({
            curValue: ModalCustomField_Mode.NEW
        })
    }

    onClickBack = () => {
        this.setState({
            curValue: ModalCustomField_Mode.EXISTING
        })
    }

    onSubmit = (result:any) => {

        this.forceUpdate()

        if (this.props.params.onSubmit) {
            this.props.params.onSubmit(result)
            return
        }

        const cfData = {
            name        : result.name,
            type        : this.props.params.customField.type,
            access      : result.access,
            params      : (result.params)?result.params:{}
        }

        if (result.symbol) {
            cfData.params.symbol = result.symbol
        }
        if (result.decimalPlaces !== null) {
            cfData.params.decimalPlaces = result.decimalPlaces
        }
        if (result.listItems) {
            cfData.params.listItems = result.listItems
            cfData.params.listItemsIncSeed = result.listItemsIncSeed
        }

        Api.CustomFields.editCustomFieldToCompany(gd.companyId, this.props.params.customField.id, cfData).done(() => {
            gd.modal.hide()
            this.props.params.callback?.(result)
        })
    }

    render() {
        debug && console.log(debug, "render() mode=", this.state.curValue)

        switch (this.state.curValue) {
            case ModalCustomField_Mode.EXISTING:
                return (
                    <CreateExisting
                        params      = {this.props.params}
                        // onClickClose = {this.closeModal}
                        onSubmit    = {this.onSubmit}
                        onClick     = {this.stopPropagation}
                        onClickNew  = {this.onClickNew}
                    />
                )

            case ModalCustomField_Mode.NEW:
                return (
                    <ModalCustomField_Form
                        params          = {this.props.params}
                        type            = {this.state.curValue}
                        onClickClose    = {this.closeModal}
                        onSubmit        = {this.onSubmit}
                        onClick         = {this.stopPropagation}
                        onClickBack     = {this.onClickBack}
                    />
                )

            case ModalCustomField_Mode.EDIT:
                const field = getTaskCustomFieldByType(this.props.params.customField.type, this.props.params.customField);

                if (field.version === 3) {
                    return (
                        <ModalCustomField_EditFieldV3
                            field           = {field}
                            customField     = {this.props.params.customField}
                            onCloseClick    = {this.closeModal}
                            callback        = {this.props.callback}
                        />
                    )

                } else {
                    return (
                        <ModalCustomField_Step2Form
                            isNew           = {false}
                            type            = {this.props.params.customField.type}
                            params          = {this.props.params}
                            onCloseClick    = {this.closeModal}
                            onSubmit        = {this.onSubmit}
                            onBackToStep1   = {()=>{}}
                        />
                    )
                }
        }
    }
}